import "regenerator-runtime/runtime";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ChakraProvider, Text } from "@chakra-ui/react";
import { FirebaseProvider } from "./contexts/FirebaseContext";
import { GameProvider } from "./contexts/GameContext";
import { HostLobby } from "./components/Host/HostLobby";
import { HostGame } from "./components/Host/HostGame";
import { Player } from "./components/Player/Player";
import { CastReceiver } from "./components/Cast/CastReceiver";
import { Audience } from "./components/Audience/Audience";
import { PlayerGate } from "./components/Player/PlayerGate";
import theme from "./theme";
import Fonts from "./theme/fonts/fonts";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Failed to find the root element");
}

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Fonts />
    <ChakraProvider theme={theme}>
      <FirebaseProvider>
        <BrowserRouter>
          <Routes>
            {/* Audience view - OUTSIDE GameProvider, no game state updates */}
            <Route path="/audience/:gameId" element={<Audience />} />

            {/* Player join flow - PlayerGate checks if full BEFORE entering GameProvider */}
            <Route
              path="/play/:gameId"
              element={
                <PlayerGate>
                  <GameProvider>
                    <Player />
                  </GameProvider>
                </PlayerGate>
              }
            />

            {/* All other routes wrapped in GameProvider */}
            <Route path="/*" element={
              <GameProvider>
                <Routes>
                  {/* Host flow - create game and play as host */}
                  <Route path="/" element={<HostLobby />} />
                  <Route path="/host/:gameId" element={<HostGame />} />

                  {/* Cast receiver - game board for TV display */}
                  <Route path="/cast" element={<CastReceiver />} />
                  <Route path="/cast/:gameId" element={<CastReceiver />} />

                  {/* Legacy route redirect - old game links still work */}
                  <Route path="/:gameId" element={<LegacyRedirect />} />
                </Routes>
              </GameProvider>
            } />
          </Routes>
        </BrowserRouter>
      </FirebaseProvider>
    </ChakraProvider>
  </React.StrictMode>
);

// Redirect old game links to the new player join route
function LegacyRedirect() {
  const gameId = window.location.pathname.replace("/", "");
  // Skip if it's a known route
  if (["host", "play", "cast"].includes(gameId.split("/")[0])) {
    return null;
  }
  return <Navigate to={`/play/${gameId}`} replace />;
}
